'use client';

import React from 'react';

interface TableRow {
  _type: string;
  _key: string;
  cells: string[];
}

interface SmartTableProps {
  value: {
    rows: TableRow[];
  };
}

export default function SmartTable({ value }: SmartTableProps) {
  if (!value || !value.rows || value.rows.length === 0) return null;

  return (
    <div className="my-10 w-full overflow-x-auto shadow-sm rounded-sm border border-border">
      <table className="w-full border-collapse text-left text-sm md:text-base">
        <thead>
          <tr className="bg-muted/50 border-b border-border transition-colors">
            {value.rows[0].cells.map((cell, index) => (
              <th
                key={index}
                className="px-6 py-4 font-bold uppercase tracking-[0.05em] text-[11px] md:text-xs text-foreground/80"
              >
                {cell}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {value.rows.slice(1).map((row, rowIndex) => (
            <tr
              key={row._key || rowIndex}
              className="border-b border-border last:border-0 hover:bg-muted/30 transition-colors"
            >
              {row.cells.map((cell, cellIndex) => (
                <td key={cellIndex} className="px-6 py-4 text-muted-foreground font-serif leading-relaxed">
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
